import { StyledCol, StyledRow } from 'src/layouts/styles';
import { ReportingPeriod } from '~/features';
import { PageLayout } from '~/layouts';

const ReportingPeriodRoute = () => {
    return (
        <PageLayout>
            <StyledRow>
                <StyledCol col={12}>
                    <ReportingPeriod />
                </StyledCol>
            </StyledRow>
        </PageLayout>
    );
};
export default ReportingPeriodRoute;
